const DEFAULT_API_BASE_URL = 'http://127.0.0.1:3000';

export const API_BASE_URL = resolveApiBaseUrl();

function resolveApiBaseUrl(): string {
  const configured = (import.meta.env.VITE_API_BASE_URL ?? '').trim();
  const rawBaseUrl = configured.length > 0 ? configured : DEFAULT_API_BASE_URL;
  return rawBaseUrl.endsWith('/') ? rawBaseUrl.slice(0, -1) : rawBaseUrl;
}
